import { NgClass } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ClassAppointmentBehaviour } from '@fitness-force/enum';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'behaviour-view',
  templateUrl: './behaviour-view.component.html',
  styleUrls: ['./behaviour-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, NgClass],
})
export class BehaviourViewComponent implements OnInit {
  behavior: any;
  activeBehavior: any;
  columnData: BehaviorSubject<any> = new BehaviorSubject(null);
  additionData: BehaviorSubject<any> = new BehaviorSubject(null);
  icon: string;
  appointmentBehaviour: any[] = [];

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (cData: any) => {
        let index = 0;
        for (const [key, value] of Object.entries(ClassAppointmentBehaviour)) {
          if (value == cData?.behaviour) {
            this.activeBehavior = { name: value, key, icon: '' };
            this.setIcon();
          }

          // For report fields
          if (
            (cData?.appt_type_behaviour !== undefined &&
              cData?.appt_type_behaviour !== null &&
              index == cData?.appt_type_behaviour) ||
            (cData?.class_type_behaviour !== undefined &&
              cData?.class_type_behaviour !== null &&
              index == cData?.class_type_behaviour) ||
            (cData?.class_behaviour !== undefined &&
              cData?.class_behaviour !== null &&
              index == cData?.class_behaviour)
          ) {
            this.activeBehavior = { name: value, key, icon: '' };
            this.setIcon();
          }
          index++;
        }
      },
    });
  }

  setIcon() {
    switch (this.activeBehavior.name) {
      case ClassAppointmentBehaviour[ClassAppointmentBehaviour.Anyone_Free]:
        this.activeBehavior.icon = 'fa fa-wallet';
        break;
      case ClassAppointmentBehaviour[ClassAppointmentBehaviour.Session_Pack]:
        this.activeBehavior.icon = 'fa-dollar';
        break;
      case ClassAppointmentBehaviour[
        ClassAppointmentBehaviour.Membership_Session_Pack
      ]:
        this.activeBehavior.icon = 'fa-dollar';
        break;
      case ClassAppointmentBehaviour[
        ClassAppointmentBehaviour.Members_Only_Session
      ]:
        this.activeBehavior.icon = 'fa fa-wallet';
        break;
    }
  }
}
